import { createFetcher } from "api/helpers"
const fetcherConfiguration = {
  method: "get",
  makeRequestUrl: (host, project) => {
    return `${host}/itsm/${project}/list_accounts`
  },
  checkRequiredArguments: () => {
  },
  makeResponseData: (json) => {
    return ({
      ...json,
      account_attribute: json.account_attribute.filter((a) => a.account_environment !== null || a.account_number !== null)
      })
  }
}
export default createFetcher(fetcherConfiguration)
